import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import './App.css';
import Components from './pages/Components';
import MetadataGroup from './pages/MetaDataGroup/metaDataGroup';

const Login = lazy(() => import('./pages/login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const AudioManagement = lazy(() => import('./pages/AudioManagement'));
const GeneralAudios = lazy(() => import('./pages/GeneralAudios'));
const ChatBot = lazy(() => import('./pages/chat-bot/components/ChatBot'));
const VoiceChatBot = lazy(() => import('./pages/VoiceChatBot'));
const RegressionTests = lazy(() => import('./pages/RegressionTests'));
const OutboundCalls = lazy(() => import('./pages/OutboundCalls'));
const DatabaseConfig = lazy(() => import('./pages/DatabaseConfig'));
const DBCompare = lazy(() => import('./pages/DBCompare'));
const DatabaseComparer = lazy(() => import('./pages/DBReportViewer'));
const ProdUtilities = lazy(() => import('./pages/ProdUtilities'));
const V3Workflow = lazy(() => import('./pages/V3Workflow'));

const LoadingFallback = () => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '16px', color: '#666' }}>
    <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #1890ff', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '16px' }}></div>
    <div>Loading page...</div>
    <style>{`
      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
    `}</style>
  </div>
);

function App() {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("userRole")?.toLowerCase(); // make it case-insensitive

  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          {token ? (
            role === "dinesh" ? (
              // Only allow Workflows for Dinesh
              <Route
                path="/*"
                element={
                  <Layout>
                    <Suspense fallback={<LoadingFallback />}>
                      <Routes>
                        <Route path="/" element={<Navigate to="/outbound-calls" replace />} />
                        <Route path="/outbound-calls" element={<OutboundCalls />} />
                        {/* Redirect all other routes */}
                        <Route path="*" element={<Navigate to="/outbound-calls" replace />} />
                      </Routes>
                    </Suspense>
                  </Layout>
                }
              />
            ) : (
              // Admin: show all routes
              <Route
                path="/*"
                element={
                  <Layout>
                    <Suspense fallback={<LoadingFallback />}>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/audio-management" element={<AudioManagement />} />
                        <Route path="/general-audios" element={<GeneralAudios />} />
                        <Route path="/chat-bot" element={<ChatBot />} />
                        <Route path="/voice-chat-bot" element={<VoiceChatBot />} />
                        <Route path="/regression-tests" element={<RegressionTests />} />
                        <Route path="/outbound-calls" element={<OutboundCalls />} />
                        <Route path="/Components" element={<Components />} />
                        <Route path="/database-config" element={<DatabaseConfig />} />
                        <Route path="/db-compare" element={<DBCompare />} />
                        <Route path="/database-comparer" element={<DatabaseComparer />} />
                        <Route path="/prod-utilities" element={<ProdUtilities />} />
                        <Route path="/v3-workflow" element={<V3Workflow />} />
                        <Route path="/metadata-group" element={<MetadataGroup />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </Suspense>
                  </Layout>
                }
              />
            )
          ) : (
            <Route path="/*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
